import dayjs from 'dayjs'
let pageMixin

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  pageMixin = {
    computed: {

    }
  }
}
else {
  pageMixin = {
    created() {
      this.$store.dispatch('filestore/getFileURL', this.thumbnail, 'font-news')
    },
    computed: {
      thumbnail() {
        let image = Object.assign({}, this.item.field_f_content_thumbnail)
        image.preset = 'front-news'
        return image
      },
      image() {
        return this.$store.getters['filestore/fileCachedImageURL'](this.thumbnail)
      },
      category() {
        return (this.item.field_x_news_category) ? this.item.field_x_news_category : ''
      },
      title() {
        return this.item.title
      },
      path() {
        return '/' + this.item.path
      },
      created() {
        return dayjs(this.item.created, 'YYYY-MM-DD hh:mm:ss Z').format('DD MMM YYYY')
      },
      content() {
        if (typeof this.item.abstract !== 'string') {
          return ''
        }
        let value = this.item.abstract.replace(/<\/?[^>]+(>|$)/g, '')
        return (value.slice(0, this.truncateText) + ((value.length > this.truncateText) ? '...' : ''))
      }
    }
  }
}

export default pageMixin
export {
  pageMixin
}
